/** Класс копирования в буфер обмена. */
class Clipboard {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.el.addEventListener("click", this.writeToClipboard);
    }

    /**
     * Копирование текста в буфер обмена с проверкой на безопасный контекст.
     * 
     * @returns {string} скопированный текст.
     */
    writeToClipboard = () => {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(this.el.innerText);
        } else {
            let textArea = document.createElement("textarea");
            textArea.value = this.el.innerText;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                document.execCommand("copy") ? res() : rej();
                textArea.remove();
            });
        }
    };
}

document.querySelectorAll(".js-clipboard").forEach((el) => new Clipboard(el));
